import * as React from "react";

import "./DropperSelect.scss";

const DropperSelect = (props) => {
  const {
    className,
    buttonLabel,
    buttonProps = { variant: "dark" },
    children,
    title,
    isOpen,
    onClick,
  } = props;

  const [active, setActive] = React.useState(isOpen);

  React.useEffect(() => {
    setActive(isOpen);
  }, [isOpen]);

  const onClickButton = () => {
    onClick?.(!active);
    setActive(!active);
  };

  return (
    <div className="wrap-dropper-select">
      {title && <label className="bold mb-2">{title}</label>}
      <div className={`dropper-select ${className || ""}`}>
        <div className="select-button" {...buttonProps} onClick={onClickButton}>
          {buttonLabel}
        </div>
        {active && <div className="backdrop-select" onClick={onClickButton} />}
        <div
          className={`dropper-select-content ${active ? "show" : ""}`}
          onClick={onClickButton}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default DropperSelect;
